import SpecialsPage from 'src/dispensary/specials';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';

SpecialsPage.layout = MainDispensaryLayout;
export default SpecialsPage;
